import { ReactNode } from "react";

import { Card } from "@design-system/Card/Card";
import { Text } from "@design-system/Text/Text";

import classes from "./DashboardWidget.module.css";

type Props = {
  title: string;
  definition?: string;
  actions?: ReactNode;
  children: ReactNode;
};

export const DashboardWidget = ({
  title,
  definition,
  actions,
  children,
}: Props) => {
  return (
    <div className={classes.fill}>
      <Card stretch grow>
        <header className={classes.header}>
          <div className={classes.heading}>
            <Text size={14} weight={600}>
              {title}
            </Text>
            {definition ? (
              <Text size={12} color="textSecondary">
                {definition}
              </Text>
            ) : null}
          </div>
          {actions ? <div className={classes.actions}>{actions}</div> : null}
        </header>
        <div className={classes.body}>{children}</div>
      </Card>
    </div>
  );
};
